import { render, staticRenderFns } from "./blocGauche.vue?vue&type=template&id=fd396956&"
import script from "./blocGauche.vue?vue&type=script&lang=ts&"
export * from "./blocGauche.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports